export const isArrayEqual = (arr1: unknown[], arr2: unknown[]): boolean => {
    return arr1.sort().join() === arr2.sort().join()
}
